// extracted by mini-css-extract-plugin
export var cardTitle = "_j9-1";
export var commentBubble = "_j9-e";
export var commentForm = "_j9-a";
export var commentInput = "_j9-b";
export var commentLabel = "_j9-d";
export var commentPrompt = "_j9-9";
export var csatCard = "_j9-0";
export var feedbackSection = "_j9-7";
export var starDisabled = "_j9-6";
export var starEmpty = "_j9-5";
export var starFilled = "_j9-4";
export var starWrapper = "_j9-3";
export var starsContainer = "_j9-2";
export var submittedComment = "_j9-c";
export var thankYouText = "_j9-8";